import React from "react";

const Story = () => {
  return <div>This is story</div>;
};

export default Story;
